import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDBadgeDot from "components/MDBadgeDot";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DefaultLineChart from "examples/Charts/LineCharts/DefaultLineChart";
import HorizontalBarChart from "examples/Charts/BarCharts/HorizontalBarChart";
import DataTable from "examples/Tables/DataTable";

import defaultLineChartTicketsData from "layouts/dashboards/sales/data/defaultLineChartTicketsData";
import defaultLineChartTurnOverData from "layouts/dashboards/sales/data/defaultLineChartTurnOverData";

import horizontalBarChartData from "layouts/dashboards/sales/data/horizontalBarChartData";
import horizontalBarChartData2 from "layouts/dashboards/sales/data/horizontalBarChartData2";
import horizontalBarChartData3 from "layouts/dashboards/sales/data/horizontalBarChartData3";
import DefaultStatisticsCard from "examples/Cards/StatisticsCards/DefaultStatisticsCard";

import { homeStatistiquesApi } from "api/statistiques";
import {
  getEventsPerformanceApi,
  getTop6EventsPerformanceApi,
  getDetailsLast6EventsApi,
  getTop6EventsByRevenueApi,
} from "api/events";

import ProductCell from "layouts/dashboards/sales/components/ProductCell";
import API_URL from "../../../config";
import MDInput from "components/MDInput";
import { Select, FormControl, InputLabel } from "@mui/material";
import { getAllCategoriesApi } from "api/categories";

function Sales() {
  const [statistiquesData, setStatistiquesData] = useState([]);
  const [formattedEventDataForTable, setFormattedEventDataForTable] = useState({
    columns: [],
    rows: [],
  });
  const [eventPerformanceRawData, setEventPerformanceRawData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [eventTypeFilter, setEventTypeFilter] = useState("");
  const [eventNameFilter, setEventNameFilter] = useState("");
  const [eventDateFilter, setEventDateFilter] = useState("");
  const [categories, setCategories] = useState([]);
  const [eventCategoryFilter, setEventCategoryFilter] = useState("");

  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [top6ChartLoading, setTop6ChartLoading] = useState(true);
  const [top6ChartError, setTop6ChartError] = useState(null);
  const [isTableLoading, setIsTableLoading] = useState(true);
  const [tableError, setTableError] = useState(null);

  const [isCategoriesLoading, setIsCategoriesLoading] = useState(true);
  const [categoriesError, setCategoriesError] = useState(null);

  const [isTop6SalesChartLoading, setIsTop6SalesChartLoading] = useState(true);
  const [top6SalesChartError, setTop6SalesChartError] = useState(null);

  const [isDetailsUsedChartLoading, setIsDetailsUsedChartLoading] = useState(true);
  const [detailsUsedChartError, setDetailsUsedChartError] = useState(null);

  const [isRevenueChartLoading, setIsRevenueChartLoading] = useState(true);
  const [revenueChartError, setRevenueChartError] = useState(null);

  const [dynamicHorizontalChartData, setDynamicHorizontalChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Billets Vendus",
        color: "dark",
        data: [],
      },
    ],
  });

  useEffect(() => {
    const fetchDetailsLast6ChartData = async () => {
      try {
        setIsDetailsUsedChartLoading(true);
        setDetailsUsedChartError(null);

        console.log("Fetching Details of Last 6 Events chart data...");

        const response = await getDetailsLast6EventsApi();

        console.log("Response received for Details chart:", response);

        if (response.success && Array.isArray(response.data)) {
          console.log("Details chart data fetched successfully:", response.data);

          const chartLabels = response.data.map(
            (item) => item.eventTitle || item.generatedEventTitle
          );
          const chartData = response.data.map((item) => item.totalUsedTickets);

          setDynamicDetailsChartData({
            labels: chartLabels,
            datasets: [{ label: "Billets Utilisés", color: "Dark", data: chartData }],
          });
        } else {
          console.error(
            "Failed to fetch Details chart data: API response not successful or data not array.",
            response
          );
          setDetailsUsedChartError(
            response.error || "API response not successful or data format incorrect."
          );
          setDynamicDetailsChartData({
            labels: [],
            datasets: [{ label: "Billets Utilisés", color: "Dark", data: [] }],
          });
        }
      } catch (err) {
        console.error("Error fetching Details chart data:", err);
        setDetailsUsedChartError(
          err.message || "An error occurred while fetching details chart data."
        );
        setDynamicDetailsChartData({
          labels: [],
          datasets: [{ label: "Billets Utilisés", color: "Dark", data: [] }],
        });
      } finally {
        setIsDetailsUsedChartLoading(false);
        console.log("Finished fetching Details chart data.");
      }
    };

    fetchDetailsLast6ChartData();
  }, []);
  const [dynamicDetailsChartData, setDynamicDetailsChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Billets Utilisés",
        color: "dark",
        data: [],
      },
    ],
  });

  const [dynamicRevenueChartData, setDynamicRevenueChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Chiffre d'Affaire",
        color: "dark",
        data: [],
      },
    ],
  });

  useEffect(() => {
    const fetchTop6RevenueChartData = async () => {
      try {
        setIsRevenueChartLoading(true);
        setRevenueChartError(null);

        console.log("Fetching Top 6 Revenue chart data...");

        const response = await getTop6EventsByRevenueApi();

        console.log("Response received for Revenue chart:", response);

        if (response.success && Array.isArray(response.data)) {
          console.log("Revenue chart data fetched successfully:", response.data);

          const chartLabels = response.data.map(
            (item) => item.eventTitle || item.generatedEventTitle
          );
          const chartData = response.data.map((item) => item.totalRevenue);

          setDynamicRevenueChartData({
            labels: chartLabels,
            datasets: [{ label: "Chiffre d'Affaire", color: "Dark", data: chartData }],
          });
        } else {
          console.error(
            "Failed to fetch Top 6 Revenue chart data: API response not successful or data not array.",
            response
          );
          setRevenueChartError(
            response.error || "API response not successful or data format incorrect."
          );
          setDynamicRevenueChartData({
            labels: [],
            datasets: [{ label: "Chiffre d'Affaire", color: "dark", data: [] }],
          });
        }
      } catch (err) {
        console.error("Error fetching Top 6 Revenue chart data:", err);
        setRevenueChartError(err.message || "An error occurred while fetching revenue chart data.");
        setDynamicRevenueChartData({
          labels: [],
          datasets: [{ label: "Chiffre d'Affaire", color: "dark", data: [] }],
        });
      } finally {
        setIsRevenueChartLoading(false);
        console.log("Finished fetching Top 6 Revenue chart data.");
      }
    };

    fetchTop6RevenueChartData();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setIsCategoriesLoading(true);
        setCategoriesError(null);

        const categoriesArray = await getAllCategoriesApi();

        if (Array.isArray(categoriesArray)) {
          setCategories(categoriesArray);
        } else {
          console.error(
            "Failed to fetch categories: API returned unexpected format.",
            categoriesArray
          );
          setCategoriesError("Failed to fetch categories: API returned unexpected format.");
          setCategories([]);
        }
      } catch (err) {
        console.error("Error fetching categories (API threw error):", err);
        setCategoriesError(err.message || "An error occurred while fetching categories.");
        setCategories([]);
      } finally {
        setIsCategoriesLoading(false);
        console.log("Finished category fetch attempt.");
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchTop6ChartData = async () => {
      try {
        setIsTop6SalesChartLoading(true);
        setTop6SalesChartError(null);

        console.log("Fetching Top 6 chart data...");

        const response = await getTop6EventsPerformanceApi();

        console.log("Response received for Top 6 chart:", response);

        if (response.success && Array.isArray(response.data)) {
          console.log("Top 6 chart data fetched successfully:", response.data);

          const chartLabels = response.data.map(
            (item) => item.eventTitle || item.generatedEventTitle
          );
          const chartData = response.data.map((item) => item.totalSoldTickets);

          setDynamicHorizontalChartData({
            labels: chartLabels,
            datasets: [{ label: "Billets Vendus", color: "dark", data: chartData }],
          });
        } else {
          console.error(
            "Failed to fetch Top 6 chart data: API response not successful or data not array.",
            response
          );
          setTop6SalesChartError(
            response.error || "API response not successful or data format incorrect."
          );
          setDynamicHorizontalChartData({
            labels: [],
            datasets: [{ label: "Billets Vendus", color: "dark", data: [] }],
          });
        }
      } catch (err) {
        console.error("Error fetching Top 6 chart data:", err);
        setTop6SalesChartError(err.message || "An error occurred while fetching Top 6 chart data.");
        setDynamicHorizontalChartData({
          labels: [],
          datasets: [{ label: "Billets Vendus", color: "dark", data: [] }],
        });
      } finally {
        setIsTop6SalesChartLoading(false);
        console.log("Finished fetching Top 6 chart data.");
      }
    };

    fetchTop6ChartData();
  }, []);

  useEffect(() => {
    getInitialData();
    getEventPerformanceData({
      category: eventCategoryFilter,
      name: eventNameFilter,
      date: eventDateFilter,
    });
  }, []);
  const getEventPerformanceData = async (filters = {}) => {
    try {
      setIsTableLoading(true);
      setTableError(null);
      const response = await getEventsPerformanceApi(filters);

      if (response.success && Array.isArray(response.data)) {
        setEventPerformanceRawData(response.data);

        const columns = [
          { Header: "événement", accessor: "événement" },
          { Header: "Nombre des tickets", accessor: "nombreTotalDePlaces" },
          { Header: "Tickets vendues", accessor: "placesVendues" },
          { Header: "Tickets Restants", accessor: "placesRestantes" },
          { Header: "invitations", accessor: "invitation" },
          { Header: "Tickets en ligne", accessor: "placesEnLigne" },
          { Header: "Tickets Hors ligne", accessor: "placesHorsLigne" },
          { Header: "chiffre d'affaire", accessor: "chiffreDaffaires" },
        ];

        const rows = response.data.map((event) => {
          const salesPercentage =
            event.nombreTotalDePlaces > 0
              ? ((event.placesVendues / event.nombreTotalDePlaces) * 100).toFixed(2)
              : 0;
          const imageObject = event.mainImageUrl;
          let imageUrl = null;
          if (imageObject && imageObject.url) {
            const formattedPath = imageObject.url;
            imageUrl = `${formattedPath}`;
          }

          return {
            événement: <ProductCell image={imageUrl} name={event.événement} />,
            nombreTotalDePlaces: event.nombreTotalDePlaces,
            placesVendues: event.placesVendues,
            placesRestantes: event.placesRestantes,
            invitation: event.invitation,
            placesEnLigne: event.placesEnLigne,
            placesHorsLigne: event.placesHorsLigne,
            chiffreDaffaires: `${event.chiffreDaffaires} Dhs`,
          };
        });

        setFormattedEventDataForTable({ columns, rows });
      } else {
        setError(response.error || "Failed to fetch event performance data");
        setFormattedEventDataForTable({ columns: [], rows: [] });
      }
    } catch (err) {
      console.error("Error fetching event performance data:", err);
      setTableError(err.message || "An error occurred while fetching data");
      setFormattedEventDataForTable({ columns: [], rows: [] });
    } finally {
      setIsTableLoading(false);
    }
  };

  const getInitialData = async () => {
    try {
      const response = await homeStatistiquesApi();
      setStatistiquesData(response.data);
    } catch (err) {
      console.log(err);
    }
  };
  const handleFilter = () => {
    const filters = {
      category: eventCategoryFilter,
      name: eventNameFilter,
      date: eventDateFilter,
    };

    getEventPerformanceData(filters);
  };

  // DefaultStatisticsCard state for the dropdown value
  const [salesDropdownValue, setSalesDropdownValue] = useState(new Date().getFullYear());
  const [customersDropdownValue, setCustomersDropdownValue] = useState("6 May - 7 May");
  const [revenueDropdownValue, setRevenueDropdownValue] = useState("6 May - 7 May");

  // DefaultStatisticsCard state for the dropdown action
  const [salesDropdown, setSalesDropdown] = useState(null);
  const [customersDropdown, setCustomersDropdown] = useState(null);
  const [revenueDropdown, setRevenueDropdown] = useState(null);

  // DefaultStatisticsCard handler for the dropdown action
  const openSalesDropdown = ({ currentTarget }) => setSalesDropdown(currentTarget);
  const closeSalesDropdown = ({ currentTarget }) => {
    setSalesDropdown(null);
    setSalesDropdownValue(currentTarget.innerText || salesDropdownValue);
  };
  const openCustomersDropdown = ({ currentTarget }) => setCustomersDropdown(currentTarget);
  const closeCustomersDropdown = ({ currentTarget }) => {
    setCustomersDropdown(null);
    setCustomersDropdownValue(currentTarget.innerText || salesDropdownValue);
  };
  const openRevenueDropdown = ({ currentTarget }) => setRevenueDropdown(currentTarget);
  const closeRevenueDropdown = ({ currentTarget }) => {
    setRevenueDropdown(null);
    setRevenueDropdownValue(currentTarget.innerText || salesDropdownValue);
  };

  // Dropdown menu template for the DefaultStatisticsCard
  const renderMenu = (state, close) => (
    <Menu
      anchorEl={state}
      transformOrigin={{ vertical: "top", horizontal: "center" }}
      open={Boolean(state)}
      onClose={close}
      keepMounted
      disableAutoFocusItem
    >
      <MenuItem onClick={close}>Last 7 days</MenuItem>
      <MenuItem onClick={close}>Last week</MenuItem>
      <MenuItem onClick={close}>Last 30 days</MenuItem>
    </Menu>
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
              <DefaultStatisticsCard
                title="Événements actifs"
                count={statistiquesData.actives}
                percentage={{
                  color: "success",
                  value: "",
                  label: "",
                }}
                dropdown={{
                  action: openSalesDropdown,
                  menu: renderMenu(salesDropdown, closeSalesDropdown),
                  value: salesDropdownValue,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DefaultStatisticsCard
                title="Nombre total des événements"
                count={statistiquesData.pendings}
                percentage={{
                  color: "success",
                  value: "",
                  label: "",
                }}
                dropdown={{
                  action: openSalesDropdown,
                  menu: renderMenu(salesDropdown, closeSalesDropdown),
                  value: salesDropdownValue,
                }}
              />
            </Grid>
          </Grid>
        </MDBox>
        <Grid container spacing={3} mb={3}>
          <Grid item xs={12} sm={12}>
            <Card>
                           
              <MDBox px={2}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel style={{ fontSize: "12px", color: "gray", opacity: 0.6 }}>
                        Catégorie d'événement
                      </InputLabel>
                      <Select
                        label="Catégorie d'événement"
                        value={eventCategoryFilter}
                        onChange={(e) => setEventCategoryFilter(e.target.value)}
                        style={{ height: "2.4rem" }}
                      >
                        <MenuItem value="">
                          <em>Tous</em>
                        </MenuItem>
                        {categories.map((category) => (
                          <MenuItem key={category._id} value={category._id}>
                            {category.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={3}>
                    <MDInput
                      placeholder="Nom d'événement"
                      size="small"
                      fullWidth
                      value={eventNameFilter}
                      onChange={(e) => setEventNameFilter(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={3}>
                    <MDInput
                      placeholder="Date d'événement"
                      size="small"
                      fullWidth
                      type="date"
                      value={eventDateFilter}
                      onChange={(e) => setEventDateFilter(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={2}>
                    <MDButton variant="gradient" color="info" fullWidth onClick={handleFilter}>
                      Filtrer
                    </MDButton>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox pt={3} px={3}>
                <MDTypography variant="h6" fontWeight="medium">
                  Événements en vente
                </MDTypography>
                <MDTypography
                  component="span"
                  variant="button"
                  fontWeight="regular"
                  color="success"
                >
                  {formattedEventDataForTable.rows.length} événement
                  {formattedEventDataForTable.rows.length !== 1 ? "s" : ""}                         
                           
                </MDTypography>
              </MDBox>
              <MDBox py={1}>
                {isTableLoading ? (
                  <MDTypography sx={{ padding: 2 }}>Loading Event Performance Data...</MDTypography>
                ) : tableError ? (
                  <MDTypography color="error" sx={{ padding: 2 }}>
                    Error: {tableError}
                  </MDTypography>
                ) : (
                  <DataTable
                    table={formattedEventDataForTable}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    isSorted={false}
                    noEndBorder
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>

        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} mt={3}>
              <Card>
                {isTop6SalesChartLoading ? (
                  <MDBox p={2} textAlign="center">
                    <MDTypography variant="body2" color="text">
                      Loading Chart Data...
                    </MDTypography>
                  </MDBox>
                ) : top6SalesChartError ? (
                  <MDBox p={2} textAlign="center">
                    <MDTypography variant="body2" color="error">
                      Error loading Chart: {top6SalesChartError?.message || top6SalesChartError}
                    </MDTypography>
                  </MDBox>
                ) : dynamicHorizontalChartData.labels &&
                  dynamicHorizontalChartData.labels.length > 0 ? (
                  <HorizontalBarChart
                    title="Meilleurs événements"
                    subTitle="Top 6 des événements par billets vendus"
                    chart={dynamicHorizontalChartData}
                  />
                ) : (
                  <MDBox p={2} textAlign="center">
                    <MDTypography variant="body2" color="text">
                      No data available for chart.
                    </MDTypography>
                  </MDBox>
                )}
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} mt={3}>
              <Card>
                {isDetailsUsedChartLoading ? (
                  <MDBox p={2} textAlign="center">
                    <MDTypography variant="body2" color="text">
                      Loading Event Details Chart Data...
                    </MDTypography>
                  </MDBox>
                ) : detailsUsedChartError ? (
                  <MDBox p={2} textAlign="center">
                    <MDTypography variant="body2" color="error">
                      Error loading Event Details Chart:{" "}
                      {detailsUsedChartError?.message || detailsUsedChartError}
                    </MDTypography>
                  </MDBox>
                ) : dynamicDetailsChartData.labels && dynamicDetailsChartData.labels.length > 0 ? (
                  <HorizontalBarChart
                    title="Détails des événements"
                    subTitle="Les détails des 6 derniers événements"
                    chart={dynamicDetailsChartData}
                  />
                ) : (
                  <MDBox p={2} textAlign="center">
                    <MDTypography variant="body2" color="text">
                      No data available for event details chart.
                    </MDTypography>
                  </MDBox>
                )}
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} mt={3}>
              <Card>
                {isRevenueChartLoading ? (
                  <MDBox p={2} textAlign="center">
                    <MDTypography variant="body2" color="text">
                      Loading Revenue Chart Data...
                    </MDTypography>
                  </MDBox>
                ) : revenueChartError ? (
                  <MDBox p={2} textAlign="center">
                    <MDTypography variant="body2" color="error">
                      Error loading Revenue Chart: {revenueChartError?.message || revenueChartError}
                    </MDTypography>
                  </MDBox>
                ) : dynamicRevenueChartData.labels && dynamicRevenueChartData.labels.length > 0 ? (
                  <HorizontalBarChart
                    title="Chiffre d'affaire d'événements"
                    subTitle="Top 6 par chiffre d'affaire"
                    chart={dynamicRevenueChartData}
                  />
                ) : (
                  <MDBox p={2} textAlign="center">
                    <MDTypography variant="body2" color="text">
                      No data available for revenue chart.
                    </MDTypography>
                  </MDBox>
                )}
              </Card>
            </Grid>
          </Grid>
        </MDBox>

        {/* <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
            <DefaultLineChart
                title="Revenue"
                description={
                  <MDBox display="flex" justifyContent="space-between">
                    <MDBox display="flex" ml={-1}>
                      <MDBadgeDot color="info" size="sm" badgeContent="Tickets vendus" />
                      <MDBadgeDot color="dark" size="sm" badgeContent="Argent gagné" />
                    </MDBox>
                    <MDBox mt={-4} mr={-1} position="absolute" right="1.5rem">
                      <Tooltip title="See which ads perform better" placement="left" arrow>
                        <MDButton
                          variant="outlined"
                          color="secondary"
                          size="small"
                          circular
                          iconOnly
                        >
                          <Icon>priority_high</Icon>
                        </MDButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                }
                chart={defaultLineChartData}
              />
            </Grid>
            <Grid item xs={12} sm={12}>

            </Grid>
          </Grid>
        </MDBox> */}

        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <DefaultLineChart
                title=""
                description={
                  <MDBox display="flex" justifyContent="space-between">
                    <MDBox display="flex" ml={-1}>
                      <MDBadgeDot color="dark" size="sm" badgeContent="Tickets vendus" />
                    </MDBox>
                    <MDBox mt={-4} mr={-1} position="absolute" right="1.5rem">
                      <Tooltip title="See which ads perform better" placement="left" arrow>
                        <MDButton
                          variant="outlined"
                          color="secondary"
                          size="small"
                          circular
                          iconOnly
                        >
                          <Icon>priority_high</Icon>
                        </MDButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                }
                chart={defaultLineChartTicketsData}
              />
            </Grid>
            <Grid item xs={12} sm={12}></Grid>
          </Grid>
        </MDBox>

        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <DefaultLineChart
                title=""
                description={
                  <MDBox display="flex" justifyContent="space-between">
                    <MDBox display="flex" ml={-1}>
                      <MDBadgeDot color="dark" size="sm" badgeContent="Argent gagné" />
                    </MDBox>
                    <MDBox mt={-4} mr={-1} position="absolute" right="1.5rem">
                      <Tooltip title="See which ads perform better" placement="left" arrow>
                        <MDButton
                          variant="outlined"
                          color="secondary"
                          size="small"
                          circular
                          iconOnly
                        >
                          <Icon>priority_high</Icon>
                        </MDButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                }
                chart={defaultLineChartTurnOverData}
              />
            </Grid>
            <Grid item xs={12} sm={12}></Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Sales;
